import { useEffect } from 'react';
// utils
import { useMonaco } from '@monaco-editor/react';
import { languages } from 'monaco-editor';
import { useScriptActionsQuery } from '@/modules/CodeEditor/CodeEditor.queries.ts';
import {
    getArgumentDescription,
    getArgumentDefaultValue
} from '@/modules/CodeEditor/CodeEditor.utils.ts';

export const useCodeEditorSettings = () => {
    const { data: actions = [] } = useScriptActionsQuery();
    const monaco = useMonaco();
    useEffect(() => {
        if (monaco) {
            monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
                validate: false
            });

            // Handlebars completion provider
            monaco.languages.registerCompletionItemProvider('handlebars', {
                provideCompletionItems: () => {
                    const suggestions = actions.map((action) => {
                        const args = Object.entries(action.arguments).map(
                            // TODO: refactor this
                            // eslint-disable-next-line sonarjs/no-nested-functions
                            ([argument, meta]) =>
                                `${argument}=${getArgumentDefaultValue(meta)}`
                        );
                        const argsStr = args.join(', ');
                        return {
                            label: action.title,
                            kind: languages.CompletionItemKind.Function,
                            insertText: `${action.title}(${argsStr})`
                        } as languages.CompletionItem;
                    });
                    return {
                        suggestions
                    };
                }
            });

            // Twig completion provider for NSL. TODO: will have its own scripts
            monaco.languages.registerCompletionItemProvider('twig', {
                provideCompletionItems: () => {
                    const suggestions = actions.map((action) => {
                        const args = Object.entries(action.arguments).map(
                            // TODO: refactor this
                            // eslint-disable-next-line sonarjs/no-nested-functions
                            ([argument, meta]) =>
                                `${argument}=${getArgumentDefaultValue(meta)}`
                        );
                        const argsStr = args.join(', ');
                        return {
                            label: action.title,
                            kind: languages.CompletionItemKind.Function,
                            insertText: `${action.title}(${argsStr})`
                        } as languages.CompletionItem;
                    });
                    return {
                        suggestions
                    };
                }
            });

            // Handlebars hover provider
            monaco.languages.registerHoverProvider('handlebars', {
                provideHover: (model, position) => {
                    const word = model.getWordAtPosition(position);
                    const action = actions.find((a) => a.title === word?.word);
                    if (action) {
                        const argDescriptions = Object.entries(
                            action.arguments
                        ).map(([argument, meta]) =>
                            getArgumentDescription(argument, meta)
                        );
                        return {
                            contents: [
                                {
                                    value: `**${word?.word}**`
                                },
                                {
                                    value: argDescriptions.join('\n')
                                }
                            ]
                        };
                    }
                }
            });

            // Twig hover provider
            monaco.languages.registerHoverProvider('twig', {
                provideHover: (model, position) => {
                    const word = model.getWordAtPosition(position);
                    const action = actions.find((a) => a.title === word?.word);
                    if (action) {
                        const argDescriptions = Object.entries(
                            action.arguments
                        ).map(([argument, meta]) =>
                            getArgumentDescription(argument, meta)
                        );
                        return {
                            contents: [
                                {
                                    value: `**${word?.word}**`
                                },
                                {
                                    value: argDescriptions.join('\n')
                                }
                            ]
                        };
                    }
                }
            });

            monaco.editor.defineTheme('newo', {
                base: 'vs',
                inherit: true,
                rules: [{ token: 'comment', foreground: '808080' }],
                colors: {}
            });
        }
    }, [actions, monaco]);
};
